import { render, staticRenderFns } from "./ReadingView.vue?vue&type=template&id=6586d889&"
import script from "./ReadingView.vue?vue&type=script&lang=js&"
export * from "./ReadingView.vue?vue&type=script&lang=js&"
import style0 from "./ReadingView.vue?vue&type=style&index=0&id=6586d889&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports